var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scrapbook-body-container",attrs:{"role":"main"}},[(!_vm.isMobile())?_c('img',{staticClass:"binder-rings",attrs:{"src":_vm.BinderRings}}):_vm._e(),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }